import React from 'react';

export default function OpeCodeModalContent() {
  return (
    <p>
      Identification number used by the U.S. Department of Education’s Office of
      Postsecondary Education (OPE) to identify schools that have Program
      Participation Agreements (PPA) so that its students are eligible to
      participate in Federal Student Financial Assistance programs under Title
      IV regulations.
    </p>
  );
}
